var map = {
	"./admin-pages/admin-pages.module": [
		"./src/app/admin-pages/admin-pages.module.ts",
		"admin-pages-admin-pages-module~user-pages-user-pages-module",
		"admin-pages-admin-pages-module"
	],
	"./user-pages/user-pages.module": [
		"./src/app/user-pages/user-pages.module.ts",
		"admin-pages-admin-pages-module~user-pages-user-pages-module",
		"user-pages-user-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;